// ---------------------------------------------------------------------------
// Testimonial content — DO NOT EDIT. Preserved exactly as provided.
// ---------------------------------------------------------------------------
const proofEn = [
  { img: "/proof/proof-1.jpeg", caption: "+$1,645 profit in a single week — with $1,250 already withdrawn." },
  { img: "/proof/proof-2.jpeg", caption: "'Thank you coach for sharing this setup.' +$302 on a $150 deposit." },
  { img: "/proof/proof-3.jpeg", caption: "Third successful withdrawal — profits keep growing since joining." },
  { img: "/proof/proof-4.jpeg", caption: "Down -$781 at 6pm, recovered to +$741 profit by 2am with GT Zone + GT Elite." },
  { img: "/proof/proof-5.jpeg", caption: "From repeated margin calls to $510 weekly profit after joining GTA Elite." },
  { img: "/proof/proof-6.jpeg", caption: "Learned GT Zone in days — around $8,000 profit over the last few days." },
  { img: "/proof/proof-7.jpeg", caption: "'Biggest profit I've made in one day.' +$2,048 from GT Zone signals." },
  { img: "/proof/proof-8.jpeg", caption: "1,000% account growth — a $6.73 deposit grown to $74.48 in one session." },
  { img: "/proof/proof-9.jpeg", caption: "A beginner from Indonesia: 'I'm new to forex but I won't give up — I'll keep learning with coach.'" },
  { img: "/proof/proof-10.jpeg", caption: "'Padu ah coach.' +$110 profit locked in before 3pm." },
  { img: "/proof/proof-11.jpeg", caption: "'I love how coach gives signals — when price misses the zone, coach walks the next setup with us. Good for newbies like me.'" },
  { img: "/proof/proof-12.jpeg", caption: "'Thank you coach for today.' Growing an account from $250 — +$111 on a single XAUUSD trade." },
  { img: "/proof/proof-13.jpeg", caption: "'Maintaining 200%–400% daily profit since last Friday, after getting the indicator. Thanks coach.'" },
];
const proofMy = [
  { img: "/proof/proof-1.jpeg", caption: "+$1,645 keuntungan dalam seminggu — $1,250 telah dikeluarkan." },
  { img: "/proof/proof-2.jpeg", caption: "'Terima kasih coach kongsikan setup ini.' +$302 atas deposit $150." },
  { img: "/proof/proof-3.jpeg", caption: "Pengeluaran ketiga berjaya — keuntungan terus bertambah sejak menyertai." },
  { img: "/proof/proof-4.jpeg", caption: "Rugi -$781 pada 6 petang, pulih kepada +$741 keuntungan menjelang 2 pagi dengan GT Zone + GT Elite." },
  { img: "/proof/proof-5.jpeg", caption: "Daripada margin call berulang kepada keuntungan mingguan $510 selepas menyertai GTA Elite." },
  { img: "/proof/proof-6.jpeg", caption: "Belajar GT Zone dalam beberapa hari — sekitar $8,000 keuntungan sejak kebelakangan ini." },
  { img: "/proof/proof-7.jpeg", caption: "'Keuntungan terbesar saya dalam sehari.' +$2,048 daripada isyarat GT Zone." },
  { img: "/proof/proof-8.jpeg", caption: "Pertumbuhan akaun 1,000% — deposit $6.73 berkembang kepada $74.48 dalam satu sesi." },
  { img: "/proof/proof-9.jpeg", caption: "Pemula dari Indonesia: 'Saya baru dalam forex tapi saya takkan menyerah — saya akan terus belajar dengan coach.'" },
  { img: "/proof/proof-10.jpeg", caption: "'Padu ah coach.' Keuntungan +$110 dikunci sebelum 3 petang." },
  { img: "/proof/proof-11.jpeg", caption: "'Saya suka cara coach bagi signal — bila tak masuk zon, coach sama-sama tunggu setup seterusnya. Bagus untuk newbie macam saya.'" },
  { img: "/proof/proof-12.jpeg", caption: "'Terima kasih coach untuk hari ini.' Nak follow grow dari $250 — +$111 pada satu dagangan XAUUSD." },
  { img: "/proof/proof-13.jpeg", caption: "'Dapat maintain 200%–400% profit harian sejak Jumaat minggu lepas, lepas dapat indicator. Terima kasih coach.'" },
];

export const translations = {
  en: {
    nav: { system: "The System", why: "Why GTA", results: "Results", joinCommunity: "Join Community", becomeMember: "Become a Member" },
    hero: {
      eyebrow: "XAUUSD · Gold Trading Ecosystem",
      headlineA: "Trade gold with a plan.",
      headlineB: "Not a prayer.",
      sub: "Structured Gold market mapping, selective trading setups, education and tools designed to help traders approach the market with a plan.",
      ctaPrimary: "Join GTA Community",
      ctaSecondary: "Become a GTA Member",
      members: "Community members",
      yearsExp: "Years trading gold",
      selective: "Quality",
      selectiveLabel: "XAUUSD setups",
      awardBadge: "WikiFX 2025 Golden Insight Award Winner",
      coach: {
        meet: "Meet your mentor",
        name: "Coach Faisal Jofry",
        cred1: "WikiFX 2025 Golden Insight Award Winner · Most Influential KOL of the Year",
        cred2: "6+ years trading XAUUSD · Mentored 7,900+ traders",
      },
      followMe: "Follow the coach",
    },
    system: {
      eyebrow: "Methodology",
      headline: "The GTA System",
      sub: "Trading shouldn't be random. Every decision starts with a plan.",
      steps: [
        { n: "01", title: "MAP", text: "Understand the important Gold levels and market structure before anything else." },
        { n: "02", title: "WAIT", text: "Patience is the edge. We wait for price to reach the areas that actually matter." },
        { n: "03", title: "EXECUTE", text: "When conditions align, we take the setup with clear parameters — entry, risk and target." },
        { n: "04", title: "MANAGE", text: "Structured risk management protects the account on every single trade." },
        { n: "05", title: "REVIEW", text: "Every trade is reviewed so the process keeps improving — win or lose." },
      ],
    },
    why: {
      eyebrow: "Why GTA",
      headline: "More than just signals.",
      sub: "GTA FX is built to give traders the structure, tools and market understanding needed to approach Gold more professionally.",
      items: [
        { title: "Market Mapping", text: "A daily read on Gold structure and the levels that matter, so you always trade with context." },
        { title: "Selective XAUUSD Setups", text: "Clear trade ideas with entry, risk and reasoning. We trade when the setup makes sense — not because we have to." },
        { title: "GT Zone Trading Tools", text: "Our proprietary market-mapping system highlights key areas of interest directly on your chart." },
        { title: "Trading Education", text: "Structured lessons that build real understanding — from the basics to reading Gold like a professional." },
        { title: "Live Market Sessions", text: "Go live with the team to break down real setups, market conditions and trade reviews." },
        { title: "Community Support", text: "Trade alongside a serious community of Gold traders instead of going it alone." },
      ],
    },
    indicator: {
      eyebrow: "Proprietary Tool",
      tag: "GT ZONE V3",
      headline: "Powered by GT Zone.",
      sub: "Our proprietary market-mapping system helps GTA traders identify important areas of interest and approach the market with more structure.",
      bullets: [
        { title: "Market mapping, automated", text: "GT Zone highlights key supply and demand areas on your Gold chart as they form." },
        { title: "Levels that matter", text: "Daily support and resistance levels (R1, R2) are plotted for you, so you always know where price may react." },
        { title: "Built for gold", text: "Tuned specifically for XAUUSD structure — works across timeframes from intraday to swing." },
      ],
      caption: "GT ZONE V3 running live on XAUUSD (15m) — actual member chart.",
      cta: "See GT Zone inside GTA",
    },
    founder: {
      eyebrow: "The Founder",
      name: "Faisal Jofry",
      role: "Founder of GTA FX · Trading Coach",
      philosophy: "My goal with GTA is simple — create traders who understand what they're doing, instead of becoming permanently dependent on signals.",
      bio: "Faisal built Global Trading Academy to bring structure to Gold trading. With years in the market and thousands of traders in the community, his focus is on process, discipline and education — not hype.",
      stats: [
        { v: "6+", l: "Years market experience" },
        { v: "7,900+", l: "GTA community" },
        { v: "2025", l: "WikiFX Golden Insight Award" },
      ],
      tags: ["Founder of GTA FX", "Trading Coach", "Market Educator", "Industry Recognition"],
    },
    results: {
      eyebrow: "Community Results",
      headline: "Real GTA community results.",
      sub: "Actual screenshots and messages shared inside the GTA community.",
      note: "Individual results vary. Trading involves risk and past performance does not guarantee future results.",
      items: proofEn,
    },
    member: {
      eyebrow: "GTA Membership",
      headline: "Ready to trade with GTA?",
      sub: "For traders who want access to the complete GTA ecosystem, structured support and our trading community.",
      cta: "Become a GTA Member",
      points: [
        "Full access to the GTA ecosystem — mapping, setups, tools and education",
        "Structured support built around your trading, not just alerts",
        "A serious community focused on process and discipline",
      ],
    },
    faq: {
      eyebrow: "FAQ",
      headline: "Questions, answered.",
      items: [
        { q: "Is GTA just another signal group?", a: "No. GTA is a complete Gold trading ecosystem — market mapping, selective setups, tools, education, live sessions and community. Signals are one part of a bigger process, not the whole product." },
        { q: "How many trades do you take?", a: "We don't trade to hit a number. Some days there are several quality setups, some days very few. We trade when the setup makes sense — quality over quantity." },
        { q: "Do I need trading experience?", a: "No. Every setup comes with clear parameters and reasoning, and our education is built to take beginners from the basics to trading Gold with structure." },
        { q: "What is GT Zone?", a: "GT Zone is our proprietary market-mapping system. It highlights important areas of interest on your Gold chart so you can approach the market with more structure." },
      ],
    },
    cta: {
      headline: "Trade gold with a plan, not a prayer.",
      sub: "Join the GTA community and see how a structured approach to Gold trading actually works.",
      button: "Join GTA Community",
      small: "Free to join · Learn the process · Leave anytime",
    },
    form: {
      title: "Become a GTA Member",
      subtitle: "Answer a few quick questions so our team can guide you into the right part of the GTA ecosystem.",
      name: "Full name",
      country: "Country",
      experience: "Trading experience",
      capital: "Trading capital",
      market: "Main market",
      broker: "Current broker",
      telegram: "Telegram username",
      contact: "Email or WhatsApp",
      optional: "optional",
      select: "Select…",
      submit: "Submit & Continue on Telegram",
      submitting: "Submitting…",
      required: "Please fill in the required fields.",
      successTitle: "You're in. One last step.",
      successText: "Thanks — we've received your details. Tap below to open Telegram and complete your GTA membership.",
      successCta: "Continue on Telegram",
      countries: ["Malaysia", "Singapore", "Indonesia", "Other"],
      experienceOpts: ["New trader", "Less than 1 year", "1–3 years", "3+ years"],
      capitalOpts: ["Below USD500", "USD500–USD999", "USD1,000–USD2,999", "USD3,000–USD9,999", "USD10,000+"],
      marketOpts: ["Gold / XAUUSD", "Forex", "Both"],
    },
    footer: {
      risk: "Risk warning: Trading forex and gold (XAUUSD) carries a high level of risk and may not be suitable for all investors. Past performance does not guarantee future results. Never trade money you cannot afford to lose.",
      rights: "Global Trading Academy. All rights reserved.",
    },
  },

  my: {
    nav: { system: "Sistem", why: "Kenapa GTA", results: "Testimoni", joinCommunity: "Sertai Komuniti", becomeMember: "Jadi Ahli" },
    hero: {
      eyebrow: "XAUUSD · Ekosistem Dagangan Emas",
      headlineA: "Berdagang emas dengan pelan.",
      headlineB: "Bukan sekadar nasib.",
      sub: "Pemetaan pasaran emas yang berstruktur, setup dagangan terpilih, pendidikan dan alatan — direka untuk membantu anda mendekati pasaran dengan satu pelan.",
      ctaPrimary: "Sertai Komuniti GTA",
      ctaSecondary: "Jadi Ahli GTA",
      members: "Ahli komuniti",
      yearsExp: "Tahun berdagang emas",
      selective: "Berkualiti",
      selectiveLabel: "Setup XAUUSD",
      awardBadge: "Pemenang WikiFX 2025 Golden Insight Award",
      coach: {
        meet: "Kenali mentor anda",
        name: "Coach Faisal Jofry",
        cred1: "Pemenang WikiFX 2025 Golden Insight Award · KOL Paling Berpengaruh Tahun Ini",
        cred2: "6+ tahun berdagang XAUUSD · Membimbing 7,900+ pedagang",
      },
      followMe: "Ikuti coach",
    },
    system: {
      eyebrow: "Metodologi",
      headline: "Sistem GTA",
      sub: "Dagangan tidak sepatutnya rawak. Setiap keputusan bermula dengan satu pelan.",
      steps: [
        { n: "01", title: "MAP", text: "Fahami paras emas penting dan struktur pasaran sebelum apa-apa lagi." },
        { n: "02", title: "WAIT", text: "Kesabaran itu kelebihan. Kami tunggu harga sampai ke kawasan yang benar-benar penting." },
        { n: "03", title: "EXECUTE", text: "Apabila keadaan sejajar, kami ambil setup dengan parameter jelas — kemasukan, risiko dan sasaran." },
        { n: "04", title: "MANAGE", text: "Pengurusan risiko berstruktur melindungi akaun pada setiap dagangan." },
        { n: "05", title: "REVIEW", text: "Setiap dagangan disemak supaya proses sentiasa bertambah baik — menang atau kalah." },
      ],
    },
    why: {
      eyebrow: "Kenapa GTA",
      headline: "Lebih daripada sekadar signal.",
      sub: "GTA FX dibina untuk memberi pedagang struktur, alatan dan pemahaman pasaran yang diperlukan untuk mendekati emas dengan lebih profesional.",
      items: [
        { title: "Pemetaan Pasaran", text: "Bacaan harian struktur emas dan paras yang penting, supaya anda sentiasa berdagang dengan konteks." },
        { title: "Setup XAUUSD Terpilih", text: "Idea dagangan jelas dengan kemasukan, risiko dan sebab. Kami berdagang bila setup masuk akal — bukan kerana terpaksa." },
        { title: "Alatan GT Zone", text: "Sistem pemetaan pasaran proprietari kami menyerlahkan kawasan penting terus pada carta anda." },
        { title: "Pendidikan Dagangan", text: "Pelajaran berstruktur yang membina pemahaman sebenar — dari asas hingga membaca emas seperti pro." },
        { title: "Sesi Pasaran Langsung", text: "Sertai sesi langsung untuk membedah setup sebenar, keadaan pasaran dan semakan dagangan." },
        { title: "Sokongan Komuniti", text: "Berdagang bersama komuniti pedagang emas yang serius, bukan bersendirian." },
      ],
    },
    indicator: {
      eyebrow: "Alat Proprietari",
      tag: "GT ZONE V3",
      headline: "Dikuasakan oleh GT Zone.",
      sub: "Sistem pemetaan pasaran proprietari kami membantu pedagang GTA mengenal pasti kawasan penting dan mendekati pasaran dengan lebih berstruktur.",
      bullets: [
        { title: "Pemetaan pasaran automatik", text: "GT Zone menyerlahkan kawasan bekalan dan permintaan utama pada carta emas anda sebaik ia terbentuk." },
        { title: "Paras yang penting", text: "Paras sokongan dan rintangan harian (R1, R2) dilakar untuk anda, supaya anda tahu di mana harga mungkin bertindak balas." },
        { title: "Dibina untuk emas", text: "Ditala khusus untuk struktur XAUUSD — berfungsi merentas jangka masa dari intraday hingga swing." },
      ],
      caption: "GT ZONE V3 berjalan secara langsung pada XAUUSD (15m) — carta sebenar ahli.",
      cta: "Lihat GT Zone dalam GTA",
    },
    founder: {
      eyebrow: "Pengasas",
      name: "Faisal Jofry",
      role: "Pengasas GTA FX · Jurulatih Dagangan",
      philosophy: "Matlamat saya dengan GTA mudah — melahirkan pedagang yang faham apa yang mereka buat, bukan bergantung selama-lamanya pada signal.",
      bio: "Faisal membina Global Trading Academy untuk membawa struktur kepada dagangan emas. Dengan pengalaman bertahun-tahun dan ribuan pedagang dalam komuniti, fokusnya adalah proses, disiplin dan pendidikan — bukan hype.",
      stats: [
        { v: "6+", l: "Tahun pengalaman" },
        { v: "7,900+", l: "Komuniti GTA" },
        { v: "2025", l: "Pemenang WikiFX Golden Insight" },
      ],
      tags: ["Pengasas GTA FX", "Jurulatih Dagangan", "Pendidik Pasaran", "Pengiktirafan Industri"],
    },
    results: {
      eyebrow: "Hasil Komuniti",
      headline: "Hasil sebenar komuniti GTA.",
      sub: "Tangkapan layar dan mesej sebenar yang dikongsi dalam komuniti GTA.",
      note: "Keputusan berbeza bagi setiap individu. Dagangan melibatkan risiko dan prestasi lepas tidak menjamin hasil masa depan.",
      items: proofMy,
    },
    member: {
      eyebrow: "Keahlian GTA",
      headline: "Sedia berdagang bersama GTA?",
      sub: "Untuk pedagang yang mahukan akses kepada ekosistem GTA yang lengkap, sokongan berstruktur dan komuniti dagangan kami.",
      cta: "Jadi Ahli GTA",
      points: [
        "Akses penuh kepada ekosistem GTA — pemetaan, setup, alatan dan pendidikan",
        "Sokongan berstruktur dibina sekitar dagangan anda, bukan sekadar alert",
        "Komuniti serius yang fokus pada proses dan disiplin",
      ],
    },
    faq: {
      eyebrow: "Soalan Lazim",
      headline: "Soalan, dijawab.",
      items: [
        { q: "Adakah GTA sekadar kumpulan signal?", a: "Tidak. GTA ialah ekosistem dagangan emas yang lengkap — pemetaan pasaran, setup terpilih, alatan, pendidikan, sesi langsung dan komuniti. Signal hanya sebahagian daripada proses yang lebih besar." },
        { q: "Berapa banyak dagangan anda ambil?", a: "Kami tidak berdagang untuk capai satu angka. Ada hari banyak setup berkualiti, ada hari sangat sedikit. Kami berdagang bila setup masuk akal — kualiti mengatasi kuantiti." },
        { q: "Perlukah saya ada pengalaman dagangan?", a: "Tidak. Setiap setup disertakan parameter dan sebab yang jelas, dan pendidikan kami membawa pemula dari asas hingga berdagang emas dengan struktur." },
        { q: "Apa itu GT Zone?", a: "GT Zone ialah sistem pemetaan pasaran proprietari kami. Ia menyerlahkan kawasan penting pada carta emas anda supaya anda boleh mendekati pasaran dengan lebih berstruktur." },
      ],
    },
    cta: {
      headline: "Berdagang emas dengan pelan, bukan sekadar nasib.",
      sub: "Sertai komuniti GTA dan lihat sendiri bagaimana pendekatan berstruktur terhadap dagangan emas benar-benar berfungsi.",
      button: "Sertai Komuniti GTA",
      small: "Percuma menyertai · Belajar prosesnya · Keluar bila-bila masa",
    },
    form: {
      title: "Jadi Ahli GTA",
      subtitle: "Jawab beberapa soalan ringkas supaya pasukan kami boleh membimbing anda ke bahagian ekosistem GTA yang sesuai.",
      name: "Nama penuh",
      country: "Negara",
      experience: "Pengalaman dagangan",
      capital: "Modal dagangan",
      market: "Pasaran utama",
      broker: "Broker semasa",
      telegram: "Nama pengguna Telegram",
      contact: "Emel atau WhatsApp",
      optional: "pilihan",
      select: "Pilih…",
      submit: "Hantar & Teruskan di Telegram",
      submitting: "Menghantar…",
      required: "Sila isi ruangan yang diperlukan.",
      successTitle: "Selesai. Satu langkah terakhir.",
      successText: "Terima kasih — kami telah menerima maklumat anda. Tekan di bawah untuk buka Telegram dan lengkapkan keahlian GTA anda.",
      successCta: "Teruskan di Telegram",
      countries: ["Malaysia", "Singapura", "Indonesia", "Lain-lain"],
      experienceOpts: ["Pedagang baru", "Kurang 1 tahun", "1–3 tahun", "3+ tahun"],
      capitalOpts: ["Bawah USD500", "USD500–USD999", "USD1,000–USD2,999", "USD3,000–USD9,999", "USD10,000+"],
      marketOpts: ["Emas / XAUUSD", "Forex", "Kedua-duanya"],
    },
    footer: {
      risk: "Amaran risiko: Dagangan forex dan emas (XAUUSD) membawa tahap risiko yang tinggi dan mungkin tidak sesuai untuk semua pelabur. Prestasi lepas tidak menjamin hasil masa depan. Jangan berdagang dengan wang yang anda tidak mampu untuk rugi.",
      rights: "Global Trading Academy. Hak cipta terpelihara.",
    },
  },

  id: {
    nav: { system: "Sistem", why: "Kenapa GTA", results: "Testimoni", joinCommunity: "Gabung Komunitas", becomeMember: "Jadi Member" },
    hero: {
      eyebrow: "XAUUSD · Ekosistem Trading Emas",
      headlineA: "Trading emas dengan rencana.",
      headlineB: "Bukan sekadar harapan.",
      sub: "Pemetaan pasar emas yang terstruktur, setup trading pilihan, edukasi, dan tools — dirancang untuk membantu trader menghadapi pasar dengan sebuah rencana.",
      ctaPrimary: "Gabung Komunitas GTA",
      ctaSecondary: "Jadi Member GTA",
      members: "Anggota komunitas",
      yearsExp: "Tahun trading emas",
      selective: "Berkualitas",
      selectiveLabel: "Setup XAUUSD",
      awardBadge: "Pemenang WikiFX 2025 Golden Insight Award",
      coach: {
        meet: "Kenali mentor Anda",
        name: "Coach Faisal Jofry",
        cred1: "Pemenang WikiFX 2025 Golden Insight Award · KOL Paling Berpengaruh Tahun Ini",
        cred2: "6+ tahun trading XAUUSD · Membimbing 7.900+ trader",
      },
      followMe: "Ikuti coach",
    },
    system: {
      eyebrow: "Metodologi",
      headline: "Sistem GTA",
      sub: "Trading tidak seharusnya acak. Setiap keputusan dimulai dengan sebuah rencana.",
      steps: [
        { n: "01", title: "MAP", text: "Pahami level emas penting dan struktur pasar sebelum hal lainnya." },
        { n: "02", title: "WAIT", text: "Kesabaran adalah keunggulan. Kami menunggu harga mencapai area yang benar-benar penting." },
        { n: "03", title: "EXECUTE", text: "Saat kondisi selaras, kami ambil setup dengan parameter jelas — entry, risiko, dan target." },
        { n: "04", title: "MANAGE", text: "Manajemen risiko yang terstruktur melindungi akun di setiap transaksi." },
        { n: "05", title: "REVIEW", text: "Setiap transaksi ditinjau agar prosesnya terus membaik — menang atau kalah." },
      ],
    },
    why: {
      eyebrow: "Kenapa GTA",
      headline: "Lebih dari sekadar sinyal.",
      sub: "GTA FX dibangun untuk memberi trader struktur, tools, dan pemahaman pasar yang dibutuhkan untuk menghadapi emas secara lebih profesional.",
      items: [
        { title: "Pemetaan Pasar", text: "Analisis harian struktur emas dan level yang penting, agar Anda selalu trading dengan konteks." },
        { title: "Setup XAUUSD Selektif", text: "Ide trading yang jelas dengan entry, risiko, dan alasan. Kami trading saat setup masuk akal — bukan karena terpaksa." },
        { title: "Tools GT Zone", text: "Sistem pemetaan pasar milik kami menyoroti area penting langsung di chart Anda." },
        { title: "Edukasi Trading", text: "Materi terstruktur yang membangun pemahaman nyata — dari dasar hingga membaca emas seperti profesional." },
        { title: "Sesi Pasar Live", text: "Ikuti sesi live untuk membedah setup nyata, kondisi pasar, dan tinjauan transaksi." },
        { title: "Dukungan Komunitas", text: "Trading bersama komunitas trader emas yang serius, bukan sendirian." },
      ],
    },
    indicator: {
      eyebrow: "Tools Eksklusif",
      tag: "GT ZONE V3",
      headline: "Ditenagai oleh GT Zone.",
      sub: "Sistem pemetaan pasar milik kami membantu trader GTA mengenali area penting dan menghadapi pasar dengan lebih terstruktur.",
      bullets: [
        { title: "Pemetaan pasar otomatis", text: "GT Zone menyoroti area supply dan demand utama di chart emas Anda begitu terbentuk." },
        { title: "Level yang penting", text: "Level support dan resistance harian (R1, R2) digambar untuk Anda, jadi Anda tahu di mana harga mungkin bereaksi." },
        { title: "Dibuat untuk emas", text: "Disetel khusus untuk struktur XAUUSD — bekerja di berbagai timeframe dari intraday hingga swing." },
      ],
      caption: "GT ZONE V3 berjalan live di XAUUSD (15m) — chart asli anggota.",
      cta: "Lihat GT Zone di GTA",
    },
    founder: {
      eyebrow: "Sang Pendiri",
      name: "Faisal Jofry",
      role: "Pendiri GTA FX · Coach Trading",
      philosophy: "Tujuan saya dengan GTA sederhana — mencetak trader yang memahami apa yang mereka lakukan, bukan bergantung selamanya pada sinyal.",
      bio: "Faisal membangun Global Trading Academy untuk membawa struktur ke dalam trading emas. Dengan pengalaman bertahun-tahun dan ribuan trader di komunitas, fokusnya adalah proses, disiplin, dan edukasi — bukan hype.",
      stats: [
        { v: "6+", l: "Tahun pengalaman" },
        { v: "7.900+", l: "Komunitas GTA" },
        { v: "2025", l: "Pemenang WikiFX Golden Insight" },
      ],
      tags: ["Pendiri GTA FX", "Coach Trading", "Edukator Pasar", "Pengakuan Industri"],
    },
    results: {
      eyebrow: "Hasil Komunitas",
      headline: "Hasil nyata komunitas GTA.",
      sub: "Screenshot dan pesan asli yang dibagikan di dalam komunitas GTA.",
      note: "Hasil berbeda untuk tiap individu. Trading mengandung risiko dan kinerja masa lalu tidak menjamin hasil di masa depan.",
      items: proofEn,
    },
    member: {
      eyebrow: "Keanggotaan GTA",
      headline: "Siap trading bersama GTA?",
      sub: "Untuk trader yang ingin akses ke ekosistem GTA lengkap, dukungan terstruktur, dan komunitas trading kami.",
      cta: "Jadi Member GTA",
      points: [
        "Akses penuh ke ekosistem GTA — pemetaan, setup, tools, dan edukasi",
        "Dukungan terstruktur yang dibangun di sekitar trading Anda, bukan sekadar alert",
        "Komunitas serius yang fokus pada proses dan disiplin",
      ],
    },
    faq: {
      eyebrow: "FAQ",
      headline: "Pertanyaan, dijawab.",
      items: [
        { q: "Apakah GTA cuma grup sinyal lagi?", a: "Bukan. GTA adalah ekosistem trading emas yang lengkap — pemetaan pasar, setup selektif, tools, edukasi, sesi live, dan komunitas. Sinyal hanyalah satu bagian dari proses yang lebih besar." },
        { q: "Berapa banyak transaksi yang kalian ambil?", a: "Kami tidak trading demi mengejar angka. Ada hari dengan beberapa setup bagus, ada hari yang sangat sepi. Kami trading saat setup masuk akal — kualitas di atas kuantitas." },
        { q: "Apakah saya perlu pengalaman trading?", a: "Tidak. Setiap setup disertai parameter dan alasan yang jelas, dan edukasi kami membawa pemula dari dasar hingga trading emas dengan struktur." },
        { q: "Apa itu GT Zone?", a: "GT Zone adalah sistem pemetaan pasar milik kami. Ia menyoroti area penting di chart emas Anda agar Anda bisa menghadapi pasar dengan lebih terstruktur." },
      ],
    },
    cta: {
      headline: "Trading emas dengan rencana, bukan sekadar harapan.",
      sub: "Gabung komunitas GTA dan lihat sendiri bagaimana pendekatan terstruktur terhadap trading emas benar-benar bekerja.",
      button: "Gabung Komunitas GTA",
      small: "Gratis bergabung · Pelajari prosesnya · Keluar kapan saja",
    },
    form: {
      title: "Jadi Member GTA",
      subtitle: "Jawab beberapa pertanyaan singkat agar tim kami bisa membimbing Anda ke bagian ekosistem GTA yang tepat.",
      name: "Nama lengkap",
      country: "Negara",
      experience: "Pengalaman trading",
      capital: "Modal trading",
      market: "Pasar utama",
      broker: "Broker saat ini",
      telegram: "Username Telegram",
      contact: "Email atau WhatsApp",
      optional: "opsional",
      select: "Pilih…",
      submit: "Kirim & Lanjut ke Telegram",
      submitting: "Mengirim…",
      required: "Mohon isi kolom yang wajib.",
      successTitle: "Berhasil. Satu langkah terakhir.",
      successText: "Terima kasih — data Anda sudah kami terima. Tekan di bawah untuk membuka Telegram dan menyelesaikan keanggotaan GTA Anda.",
      successCta: "Lanjut ke Telegram",
      countries: ["Malaysia", "Singapura", "Indonesia", "Lainnya"],
      experienceOpts: ["Trader baru", "Kurang dari 1 tahun", "1–3 tahun", "3+ tahun"],
      capitalOpts: ["Di bawah USD500", "USD500–USD999", "USD1.000–USD2.999", "USD3.000–USD9.999", "USD10.000+"],
      marketOpts: ["Emas / XAUUSD", "Forex", "Keduanya"],
    },
    footer: {
      risk: "Peringatan risiko: Trading forex dan emas (XAUUSD) memiliki tingkat risiko yang tinggi dan mungkin tidak cocok untuk semua investor. Kinerja masa lalu tidak menjamin hasil di masa depan. Jangan pernah trading dengan uang yang tidak mampu Anda tanggung kerugiannya.",
      rights: "Global Trading Academy. Semua hak dilindungi.",
    },
  },
};

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "my", label: "BM" },
  { code: "id", label: "ID" },
];

export const TELEGRAM_URL = "https://t.me/GTAFX_11";
export const MEMBER_TELEGRAM_URL = "https://t.me/m/WcWE2talOTNl";

// Canonical (English) values stored for leads, regardless of display language.
export const LEAD_CANONICAL = {
  country: ["Malaysia", "Singapore", "Indonesia", "Other"],
  experience: ["New trader", "Less than 1 year", "1-3 years", "3+ years"],
  capital: ["Below USD500", "USD500-USD999", "USD1,000-USD2,999", "USD3,000-USD9,999", "USD10,000+"],
  market: ["Gold / XAUUSD", "Forex", "Both"],
};

export const SOCIAL_LINKS = {
  telegram: "https://t.me/GTAFX_11",
  instagram: "https://www.instagram.com/faisaljofry?igsh=ZGc4bmhnMXlpbXAw&igsi=ZGc4bmhnMXlpbXAw&utm_source=qr",
  tiktok: "https://www.tiktok.com/@faisal.jofry?_r=1&_t=ZS-98z2TXgJic6",
  facebook: "https://www.facebook.com/share/19TTFqwZzv/?mibextid=wwXIfr",
};
